// Disabled for redux
/* eslint-disable no-shadow */
import { useEffect, useState } from 'react';
import { Auth, Hub } from 'aws-amplify';
import { connect } from 'react-redux';
import LogRocket from 'logrocket';

import { setUserData } from '../app/actions';
import { authStatuses, logRocketEnv } from '../util/constants';

const propsVal = {};
const mapStateToProps = () => propsVal;

const mapDispatchToProps = { setUserData };

const AmplifyAuthChangeHandler = connect(
   mapStateToProps,
   mapDispatchToProps
)(({ setUserData }) => {
   const [amplifyAuthState, setAmplifyAuthState] = useState(null);

   useEffect(() => {
      const handler = ({ payload }) => {
         if (payload.event === 'signIn') {
            setAmplifyAuthState('signedIn');
         } else if (payload.event === 'signOut') {
            setAmplifyAuthState('signedOut');
         }
      };

      Hub.listen('auth', handler);

      return () => {
         Hub.remove('auth', handler);
      };
   }, []);

   useEffect(() => {
      // null is on app load, signedIn and signedOut are on auth changes
      if ([null, 'signedIn', 'signedOut'].includes(amplifyAuthState)) {
         // Keep user auth status pending for initial check, any future checks get loading status
         if (amplifyAuthState != null) {
            setUserData({ status: authStatuses.loading });
         }

         Auth.currentAuthenticatedUser({ bypassCache: true })
            .then((res) => {
               const {
                  username: userId,
                  attributes: { email },
               } = res;

               if (logRocketEnv.enabled) {
                  LogRocket.identify(userId);
               }

               setUserData({
                  status: authStatuses.authenticated,
                  userId,
                  email,
               });
            })
            .catch(() => {
               setUserData({ status: authStatuses.unauthenticated });
            });
      }
   }, [amplifyAuthState, setUserData]);

   return null;
});

export { AmplifyAuthChangeHandler };
